import React from 'react';
import { PickingModeCarrierTypesViewStore } from 'modules/order/stores';
import { PickingModeCarrierTypesTemplate } from 'themes/modules/order/pages';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore, componentProps) => new PickingModeCarrierTypesViewStore(rootStore, componentProps), 'pickingModeCarrierTypesViewStore')
class PickingModeCarrierTypes extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return <PickingModeCarrierTypesTemplate {...this.props} />;
	}
}

export default PickingModeCarrierTypes;
